import { ChalkEmployeeGuard } from "@/components/admin/ChalkEmployeeGuard";
import { Icon } from "@/components/icons/Icon";
import { useGlobalAppState } from "@/utils/app-state";
import { useIsImpersonating } from "@/utils/hooks/use-is-impersonating";
import type { FC } from "react";

export const CollapsedNavbarAdminIndicators: FC = () => {
  const {
    state: { adminMode },
  } = useGlobalAppState();
  const isImpersonating = useIsImpersonating({ cookieOnly: true });
  if (!adminMode && !isImpersonating) return null;

  return (
    <ChalkEmployeeGuard
      ignoreAdminMode
      hideTooltip
      className="flex w-[30px] flex-col items-center gap-cds-2 rounded-cds-6"
    >
      {adminMode && (
        <span role="img" aria-label="Admin mode enabled" className="flex h-7 items-center">
          <Icon name="wrench" size="md" aria-hidden />
        </span>
      )}
      {isImpersonating && (
        <span role="img" aria-label="Impersonating" className="flex h-7 items-center">
          <Icon name="personalization" size="md" aria-hidden />
        </span>
      )}
    </ChalkEmployeeGuard>
  );
};
